"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RichText = /** @class */ (function (_super) {
    __extends(RichText, _super);
    function RichText(markup, font, color) {
        var _this = _super.call(this) || this;
        _this._color = undefined;
        _this._font = undefined;
        _this._markup = undefined;
        _this.lineHeight = 0;
        _this.lineWidth = null;
        _this.maxWidth = null;
        _this.outline = 0;
        _this.textAlign = "left";
        _this.textBaseline = "top";
        _this.textBlocks = undefined;
        _this.DisplayObject_constructor();
        _this._color = color;
        _this._font = font;
        _this._markup = markup;
        _this.textBlocks = _this.convertMarkupToTextBlocks();
        return _this;
    }
    RichText.prototype.draw = function (context, ignoreCache) {
        var _a;
        if (this.DisplayObject_draw(context, ignoreCache)) {
            return true;
        }
        context.fillStyle = this._color || "#000";
        var lineHeight = this.lineHeight || this.getMaxHeight();
        var words = (_a = this.textBlocks) === null || _a === void 0 ? void 0 : _a.reduce(function (listOfWords, textBlock) {
            this.prepareContext(context, textBlock);
            var words = String(textBlock.text).split(/(\s|\r\n|\r|\n)/);
            words.forEach(function (word) { return listOfWords.push({
                color: textBlock.color,
                font: textBlock.font,
                text: word,
                width: context.measureText(word).width,
            }); });
            return listOfWords;
        }.bind(this), []);
        var lineOfWords = [];
        var lineCount = 0;
        var lineWidth = 0;
        words === null || words === void 0 ? void 0 : words.forEach(function (word) {
            var wordWidth = word.width || 0;
            if ((this.lineWidth && lineWidth + wordWidth > this.lineWidth) ||
                word.text === "\r\n" ||
                word.text === "\n" ||
                word.text === "\r") {
                this.drawLineOfWords(context, lineOfWords, lineWidth, lineCount * lineHeight);
                lineOfWords = [];
                lineOfWords.push(word);
                lineWidth = wordWidth;
                lineCount += 1;
            }
            else {
                lineOfWords.push(word);
                lineWidth += wordWidth;
            }
        }.bind(this));
        if (lineOfWords.length > 0) {
            this.drawLineOfWords(context, lineOfWords, lineWidth, lineCount * lineHeight);
        }
        return true;
    };
    RichText.prototype.getMeasuredLineHeight = function () {
        return this.getMeasuredWidth("M") * 1.2;
    };
    RichText.prototype.convertMarkupToTextBlocks = function () {
        var _this = this;
        var _a;
        var markupChunks = (_a = this._markup) === null || _a === void 0 ? void 0 : _a.split(/(<b[^>]*>|<\/b>|<i[^>]*>|<\/i>)/);
        var color = this._color;
        var state = "text";
        this.textBlocks = markupChunks === null || markupChunks === void 0 ? void 0 : markupChunks.reduce(function (textBlocks, chunk, index) {
            if (chunk === "") {
                return textBlocks;
            }
            var token = _this.getToken(chunk);
            if (state === "bold") {
                if (token === "boldClose") {
                    state = "text";
                }
                else if (token === "italicOpen") {
                    state = "bold-italic";
                }
                else if (token === "text") {
                    var oldColor = color;
                    if (index - 1 >= 0) {
                        var previousChunk = markupChunks[index - 1];
                        if ((previousChunk === "<b>" || previousChunk === "<i>") && previousChunk.includes("style=")) {
                            color = _this.getColor(previousChunk);
                        }
                    }
                    textBlocks.push({
                        color: color,
                        font: "bold ".concat(_this._font),
                        text: chunk,
                    });
                    color = oldColor;
                }
                else {
                    throw new Error("Invalid markup: looking for text or closing bold tag and found a ".concat(chunk, " tag."));
                }
            }
            else if (state === "bold-italic") {
                if (token === "boldClose") {
                    state = "italic";
                }
                else if (token === "italicClose") {
                    state = "bold";
                }
                else if (token === "text") {
                    var oldColor = color;
                    if (index - 1 >= 0) {
                        var previousChunk = markupChunks[index - 1];
                        if ((previousChunk === "<b>" || previousChunk === "<i>") && previousChunk.includes("style=")) {
                            color = _this.getColor(previousChunk);
                        }
                    }
                    textBlocks.push({
                        color: color,
                        font: "bold italic ".concat(_this._font),
                        text: chunk,
                    });
                    color = oldColor;
                }
                else {
                    throw new Error("Invalid markup: looking for text or closing bold or italic tag and found a ".concat(chunk, " tag."));
                }
            }
            else if (state === "italic") {
                if (token === "boldOpen") {
                    state = "bold-italic";
                }
                else if (token === "italicClose") {
                    state = "text";
                }
                else if (token === "text") {
                    var oldColor = color;
                    if (index - 1 >= 0) {
                        var previousChunk = markupChunks[index - 1];
                        if ((previousChunk === "<b>" || previousChunk === "<i>") && previousChunk.includes("style=")) {
                            color = _this.getColor(previousChunk);
                        }
                    }
                    textBlocks.push({
                        color: color,
                        font: "italic ".concat(_this._font),
                        text: chunk,
                    });
                    color = oldColor;
                }
                else {
                    throw new Error("Invalid markup: looking for text or opening italic tag and found a ".concat(chunk, " tag."));
                }
            }
            else if (state === "text") {
                if (token === "boldOpen") {
                    state = "bold";
                }
                else if (token === "italicOpen") {
                    state = "italic";
                }
                else if (state === "text" && token === "text") {
                    textBlocks.push({
                        color: color,
                        font: _this._font,
                        text: chunk,
                    });
                }
                else {
                    throw new Error("Invalid markup: looking for text and found a ".concat(chunk, " tag."));
                }
            }
            return textBlocks;
        }, []);
        return this.textBlocks;
    };
    RichText.prototype.drawLineOfWords = function (context, lineOfWords, width, y) {
        width = this.trimLineOfWords(lineOfWords).reduce(function (totalWidth, word) { return totalWidth + (word.width || 0); }, 0);
        var x = 0;
        if (this.textAlign === "center") {
            x = -width / 2;
        }
        else if (this.textAlign === "left") {
            x = 0;
        }
        else if (this.textAlign === "right") {
            x = -width;
        }
        lineOfWords.forEach(function (word) {
            this.prepareContext(context, {
                color: word.color,
                font: word.font,
                textAlign: "left",
            });
            this.drawText(context, word.text, x, y);
            x += word.width || 0;
        }.bind(this));
    };
    RichText.prototype.drawText = function (context, text, x, y) {
        if (this.outline) {
            context.strokeText(text, x, y, this.maxWidth || 0xffff);
        }
        else {
            context.fillText(text, x, y, this.maxWidth || 0xffff);
        }
    };
    RichText.prototype.getColor = function (markup) {
        return markup
            .split("=")
            .slice(1)[0]
            .replace(/>/g, "")
            .replace(/('|")/g, "")
            .split(":")
            .slice(1)[0]
            .replace(/;/g, "")
            .trim();
    };
    RichText.prototype.getMaxHeight = function () {
        return (this.getMaxWidth() || 0) * 1.2;
    };
    RichText.prototype.getMaxWidth = function () {
        var _this = this;
        var _a;
        return (((_a = this.textBlocks) === null || _a === void 0 ? void 0 : _a.reduce(function (maxWidth, textBlock) {
            var width = _this.getMeasuredWidth({
                font: textBlock.font,
                text: "M",
            });
            return maxWidth > width ? maxWidth : width;
        }, 0)) || 0);
    };
    RichText.prototype.getMetrics = function (word) {
        var _a;
        var context = Text._workingContext;
        context === null || context === void 0 ? void 0 : context.save();
        var text = typeof word === "object" ? word.text : word;
        var metrics = (_a = this.prepareContext(context, word)) === null || _a === void 0 ? void 0 : _a.measureText(text);
        context === null || context === void 0 ? void 0 : context.restore();
        return metrics;
    };
    RichText.prototype.getMeasuredWidth = function (word) {
        var metrics = this.getMetrics(word);
        return metrics.width || 0;
    };
    RichText.prototype.getToken = function (markup) {
        if (markup === "</b>") {
            return "boldClose";
        }
        else if (markup.slice(0, 2) === "<b" && markup.slice(-1) === ">") {
            return "boldOpen";
        }
        else if (markup === "</i>") {
            return "italicClose";
        }
        else if (markup.slice(0, 2) === "<i" && markup.slice(-1) === ">") {
            return "italicOpen";
        }
        else {
            return "text";
        }
    };
    RichText.prototype.prepareContext = function (context, word) {
        if (context) {
            context.font = (typeof word === "object" && word.font) || this._font || "10px sans-serif";
            context.fillStyle = (typeof word === "object" && word.color) || this._color || "#000";
            context.textAlign = (typeof word === "object" && word.textAlign) || this.textAlign || "left";
            context.textBaseline = this.textBaseline || "top";
            context.lineJoin = "miter";
            context.miterLimit = 2.5;
        }
        return context;
    };
    RichText.prototype.trimLineOfWords = function (lineOfWords) {
        var start = lineOfWords.findIndex(function (word) { return word.text.trim().length > 0; });
        lineOfWords.splice(0, start);
        lineOfWords.reverse();
        start = lineOfWords.findIndex(function (word) { return word.text.trim().length > 0; });
        lineOfWords.splice(0, start);
        lineOfWords.reverse();
        return lineOfWords;
    };
    return RichText;
}(createjs.DisplayObject));
RichText.H_OFFSETS = {
    center: -0.5,
    end: -1,
    left: 0,
    right: -1,
    start: 0,
};
RichText.V_OFFSETS = {
    alphabetic: -0.8,
    bottom: -1,
    hanging: -0.01,
    ideographic: -0.85,
    middle: -0.4,
    top: 0,
};
var canvas = createjs.createCanvas
    ? createjs.createCanvas()
    : document.createElement("canvas");
if (!canvas.getContext) {
    Text._workingContext = canvas.getContext("2d");
    canvas.width = canvas.height = 1;
}
Object.defineProperty(RichText.prototype, "color", {
    get: function () {
        return this._color;
    },
    set: function (color) {
        this._color = color;
        this.textBlocks = this.convertMarkupToTextBlocks();
    },
    enumerable: true,
});
Object.defineProperty(RichText.prototype, "font", {
    get: function () {
        return this._font;
    },
    set: function (font) {
        this._font = font;
        this.textBlocks = this.convertMarkupToTextBlocks();
    },
    enumerable: true,
});
Object.defineProperty(RichText.prototype, "markup", {
    get: function () {
        return this._markup;
    },
    set: function (markup) {
        this._markup = markup;
        this.textBlocks = this.convertMarkupToTextBlocks();
    },
    enumerable: true,
});
createjs.RichText = createjs.promote(RichText, "DisplayObject");
exports.default = RichText;
//# sourceMappingURL=rich-text.js.map
//# sourceMappingURL=module.js.map